// extracted by mini-css-extract-plugin
export default {"footerBg":"e-z","footerTopLinks":"f-z","footerFeedback":"g-z","footerSocial":"h-z","footerLegalLinks":"i-z","footerIconCards":"j-z","footerBotCopy":"k-z"};